module.exports = (function anonymous(locals, filters, escape, rethrow
/**/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<tr class="sponsor">\n<td class="sponsor-image">\n  ');3; if (url) { ; buf.push('\n  <a href="', escape((4,  url )), '"><img src="', escape((4,  logo )), '"></img></a>\n  ');5; } else { ; buf.push('\n  <img src="', escape((6,  logo )), '"></img>\n  ');7; } ; buf.push('\n</td>\n<td class="sponsor-name">\n  ');10; if (url) { ; buf.push('\n  <a href="', escape((11,  url )), '"><h3>', escape((11,  name )), '</h3></a>\n  ');12; } else { ; buf.push('\n  <h3>', escape((13,  name )), '</h3>\n  ');14; } ; buf.push('\n</td>\n<td class="sponsor-amount">\n  <h3>$ ', escape((17,  amount.toFixed(2) )), '</h3>\n</td>\n</tr>\n'); })();
} 
return buf.join('');
})